import SuccessPlanCard from "components/summary/success-plan/components/SuccessPlanCard";
import { SuccessPlanState } from "components/summary/success-plan/state/successPlan.types";
import styles from "../SuccessPlan.module.scss";
import { Divider, Tooltip, Typography } from "@mui/material";
import MButton from "components/momentum/MButton";
import { ContactItemViewer, useSpContext } from "components/summary/success-plan";
import { AuthProvider } from "pages";
import { FEATURE_KEY } from "constant";
import { useContext } from "react";
import React from "react";
import { InfoOutlined } from "@mui/icons-material";

type CustomerDetailSectionProps = {
  spState: SuccessPlanState;
};

const TitleSlot = ({ onClickCallback }: { onClickCallback?: () => void }) => {
  const { features } = useContext(AuthProvider);

  const editable = features.includes(FEATURE_KEY.EDIT_EXPAND_PLAN_REVAMP);
  return (
    <div
      className={styles["sp-flex-horizontal"]}
      style={{ justifyContent: "space-between", alignItems: "center", flex: 1 }}
    >
      <Typography className={styles["card-title"]}>Customer Details</Typography>
      {editable && (
        <MButton
          buttonType="blue"
          onClick={onClickCallback}
        >
          Edit Customer Details
        </MButton>
      )}
    </div>
  );
};

const CustomerDetailSection = ({ spState }: CustomerDetailSectionProps) => {
  const { spData } = spState;
  const { dispatch } = useSpContext();

  const {
    highTouchSegment,
    hasMsftContract,
    relationships,
    knowDecMaker,
    msftRenewalDate,
    recentExecutive,
    competitorContacts,
  } = spData;

  const hasMsftContractFlag = hasMsftContract === 1;
  const isKnowDecMaker = knowDecMaker === 1;

  const handleEditCustomerDetails = () => {
    dispatch({ type: "setStepIndicator", payload: "customerDetailStepper" });
    dispatch({ type: "setMode", payload: "edit" });
  };

  return (
    <SuccessPlanCard titleSlot={<TitleSlot onClickCallback={handleEditCustomerDetails} />}>
      <div className={styles["grid-two-lane"]}>
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          <Typography className={styles["sp-label-gray"]}>High Touch Segmentation</Typography>
          <Tooltip
            title="Advocate / Invested: Activity engaged, health usage, regular engagement cadence. Unresponse / Dormant: Minimal engagement, competitor preference, migration risk."
            className={styles["info-tip"]}
          >
            <InfoOutlined fontSize="small" />
          </Tooltip>
        </div>

        <Typography className={styles["sp-label"]}>{highTouchSegment || "N/A"}</Typography>

        <Typography className={styles["sp-label-gray"]}>
          Does Customer have a Microsoft Contract?
        </Typography>
        <Typography className={styles["sp-label"]}>
          {hasMsftContract === 1 ? "Yes" : "No"}
        </Typography>
        {hasMsftContractFlag && (
          <>
            <Typography className={styles["sp-label-gray"]}>What Type of Contract?</Typography>
            <Typography className={styles["sp-label"]}>{spData.contractType}</Typography>
            <Typography className={styles["sp-label-gray"]}>
              Microsoft Contract Renewal Date:
            </Typography>
            <Typography className={styles["sp-label"]}>
              {msftRenewalDate ? new Date(msftRenewalDate).toLocaleDateString() : ""}
            </Typography>
          </>
        )}

        <Typography className={styles["sp-label-gray"]}>
          What level of relationship do you have with the customer:
        </Typography>

        <div className={styles["form-field-wrapper"]}>
          {Array.isArray(relationships) && relationships.length > 0 ? (
            <Typography className={styles["sp-label"]}>
              {relationships
                .map((item: string) => {
                  if (item.startsWith("Other%-%")) {
                    const content = item.split("%-%")[1] || "";
                    return content ? `Other - ${content}` : "Other";
                  }
                  return item;
                })
                .join(", ")}
            </Typography>
          ) : (
            <Typography className={styles["sp-label"]}>N/A</Typography>
          )}
        </div>

        <Typography className={styles["sp-label-gray"]}>
          Do you know who the decision maker is?
        </Typography>
        <Typography className={styles["sp-label"]}>{knowDecMaker === 1 ? "Yes" : "No"}</Typography>

        {isKnowDecMaker && competitorContacts.length > 0 && (
          <div className={`${styles["sp-flex-vertical"]} ${styles["grid-column-span-2"]}`}>
            <Divider />
          </div>
        )}

        {isKnowDecMaker &&
          competitorContacts.length > 0 &&
          competitorContacts.map((contact: any, index: number) => (
            <React.Fragment key={`contact-fragment-${index}`}>
              <ContactItemViewer item={contact} />
              {index !== competitorContacts.length - 1 && (
                <div className={`${styles["sp-flex-vertical"]} ${styles["grid-column-span-2"]}`}>
                  <Divider />
                </div>
              )}
            </React.Fragment>
          ))}
        {isKnowDecMaker && competitorContacts.length > 0 && (
          <div className={`${styles["sp-flex-vertical"]} ${styles["grid-column-span-2"]}`}>
            <Divider />
          </div>
        )}

        <div className={`${styles["sp-flex-vertical"]} ${styles["grid-column-span-2"]}`}>
          <Typography className={styles["sp-label-gray"]}>
            Are there any recent executive changes(last 18 months)?
          </Typography>
          <div
            dangerouslySetInnerHTML={{
              __html: recentExecutive ?? "",
            }}
            style={{
              height: 200,
              border: "1px solid #ddd",
              borderRadius: 8,
              overflowY: "auto",
              padding: 14,
            }}
          ></div>
        </div>
        {/* <Typography className={styles["sp-label-gray"]}>
          What is the level of customer responsiveness?
        </Typography>
        <Typography className={styles["sp-label"]}>
          {responsiveLvl ?? "N/A"}
        </Typography> */}
      </div>
    </SuccessPlanCard>
  );
};

export default CustomerDetailSection;
